export const SLICE_NAME = 'statistics';

export const UPDATE_STATISTICS_SUCCESS = `${SLICE_NAME}/UPDATE_STATISTICS_SUCCESS`;
export const UPDATE_STATISTICS_FAILURE = `${SLICE_NAME}/UPDATE_STATISTICS_FAILURE`;
export const GET_STATISTICS_SUCCESS = `${SLICE_NAME}/GET_STATISTICS_SUCCESS`;
export const GET_STATISTICS_FAILURE = `${SLICE_NAME}/GET_STATISTICS_FAILURE`;
export const UPDATE_DAILY_STATISTICS_SUCCESS = `${SLICE_NAME}/UPDATE_DAILY_STATISTICS_SUCCESS`;
